//#region ../src/utils/build-info.ts
/**
* Each global read as an explicit `globalThis.__NAME__` expression: that is
* the text Vite's `define` replaces in a build (the app's own code and its
* dependencies alike), and the property its dev client assigns. A computed
* `globalThis[name]` - or an alias of `globalThis` - would be replaced in
* neither, which is why each cast is written out in place (the cast is
* erased; the emitted code reads `globalThis.__NAME__`).
*/
function readInjectedValues() {
	return {
		__BUILD_COMMIT__: globalThis.__BUILD_COMMIT__,
		__APP_VERSION__: globalThis.__APP_VERSION__,
		__LIB_VERSION__: globalThis.__LIB_VERSION__,
		__FW_VERSION__: globalThis.__FW_VERSION__,
		__BUILD_TIME__: globalThis.__BUILD_TIME__
	};
}
function readInjectedString(name) {
	const value = readInjectedValues()[name];
	if (typeof value !== "string") throw new Error(`Missing or invalid build metadata: ${name}`);
	return value;
}
/**
* The build stamp. Throws when a constant was never injected (a unit test,
* or an app without the `define` block): the caller decides whether that
* costs a label or a field, never the whole record.
*/
function getBuildInfo() {
	return {
		commitHash: readInjectedString("__BUILD_COMMIT__"),
		appVersion: readInjectedString("__APP_VERSION__"),
		libraryVersion: readInjectedString("__LIB_VERSION__"),
		frameworkVersion: readInjectedString("__FW_VERSION__"),
		buildTime: readInjectedString("__BUILD_TIME__")
	};
}
//#endregion
export { getBuildInfo };
